import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({ rootNodeId: 'premium-payment$root' });

export const PDPPremiumPaymentMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
